import request from "../utils/request";

export function fetcTableData(params) {
  // is_paginated=0 page page_size
  // let data = [
  //   {
  //     id: "id",
  //     code_soato: "code_soato",
  //     region: "region",
  //     sector_name: "sector_name",
  //     status: {
  //       color: "warning",
  //       title: "Пыльная буря "
  //     },
  //     location: "location",
  //     date: "date"
  //   }
  // ];
  // return Promise.resolve({ data: { data, count: 1 } });
  return request({
    url: "/api/orgs/integration/geology/landslide/",
    method: "get",
    params
  });
}
export function fetchChartData(params) {
  // is_paginated=0 page page_size

  return Promise.resolve([]);
  // return request({
  //   url: "/api/orgs/geology/water-deposits/",
  //   method: "get",
  //   params
  // });
}
export function fetchLocationData(params) {
  // is_paginated=0 page page_size

  return Promise.resolve({});
  // return request({
  //   url: "/api/orgs/geology/water-deposits/",
  //   method: "get",
  //   params
  // });
}
